import React, { useCallback, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Alerts } from "@components/common/AlertModal";
import axios, { AxiosError } from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducer";
// import { useNavigate } from "react-router-dom";
import { colors, Title1, Title2 } from "@utils/ui_palette";
import { rgba } from "emotion-rgba";
import PageNavigation from "@components/common/PageNavigation";

interface IUser {
  id: number;
  createdAt: string;
  title: string;
  content: string;
  useremail: string;
  user_id: number;
}

function InqueryList() {
  // const navigation = useNavigate();
  const accessToken = useSelector(
    (state: RootState) => state.user.userInfo.accessToken
  );
  const [userInfo, setUserInfo] = useState<null | IUser[]>(null);
  const [userTotal, setUserTotal] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [pagination, setPagination] = useState<number>(1);
  const [current, setCurrent] = useState<null | IUser>(null);

  const getUser = useCallback(
    async (page: number) => {
      setPagination(page);

      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/admin/inquery-list`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        setUserInfo(data.inquery_list);
        setUserTotal(data.total);
        setTotalPage(data.total_page);
      } catch (error) {
        const errorResponse = (error as AxiosError).response;

        if (errorResponse && (errorResponse.data as any).message) {
          Alerts.show({
            title: (errorResponse.data as any).message,
          });
        }
      }
    },
    [accessToken, setUserInfo, setUserTotal, setTotalPage]
  );

  const handleContent = useCallback(
    (user: IUser) => {
      setCurrent(user);
    },
    [setCurrent]
  );

  useEffect(() => {
    getUser(1);
  }, [getUser]);

  return (
    <Container>
      <TitleBox>
        <Title1 align="left">Inquery List</Title1>
        <Title2>Total {userTotal} users</Title2>
      </TitleBox>

      <UserListGroup>
        <UserListItems>
          <Row isHeader width={5}>
            ID
          </Row>
          <Row isHeader width={25}>
            Email
          </Row>
          <Row isHeader width={50}>
            title
          </Row>
          <Row isHeader width={20}>
            Created Date
          </Row>
        </UserListItems>

        {userInfo &&
          userInfo.length > 0 &&
          userInfo.map((user) => (
            <>
              <UserListItems onClick={() => handleContent(user)}>
                <Row isHeader={false} width={5}>
                  {user.id}
                </Row>
                <Row isHeader={false} width={25}>
                  {user.useremail}
                </Row>
                <Row isHeader={false} width={50}>
                  {user.title}
                </Row>
                <Row isHeader={false} width={20}>
                  {user.createdAt}
                </Row>
              </UserListItems>

              {current && current.id === user.id && (
                <ContentBox>{user.content}</ContentBox>
              )}
            </>
          ))}
      </UserListGroup>

      <PagenationContain>
        <PageNavigation
          activePage={pagination}
          itemsCountPerPage={10}
          totalItemsCount={totalPage}
          pageRangeDisplayed={5}
          onChange={(page) => getUser(page)}
        />
      </PagenationContain>
    </Container>
  );
}

const Container = styled.div`
  width: 1024px;
  padding: 20px;
`;

const PagenationContain = styled.div`
  margin-top: 80px;
`;

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UserListGroup = styled.div`
  margin-top: 30px;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid ${colors.Gray30};
  background-color: ${colors.White};
`;

const UserListItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
  cursor: pointer;

  &:hover {
    background-color: ${rgba(colors.Gray30, 0.3)};
  }
`;

const Row = styled.div<{ width: number; isHeader: boolean }>`
  display: flex;
  align-items: center;
  text-align: center;
  flex-basis: ${(props) => `${props.width}%`};
  height: 50px;
  font-weight: ${(props) => (props.isHeader ? 700 : 400)};
  color: ${(props) => (props.isHeader ? colors.Primary50 : colors.Black)};
`;

const ContentBox = styled.div`
  padding: 30px;
  background-color: ${rgba(colors.Gray10, 0.7)};
`;

export default InqueryList;
